import { Dashboard } from "modules/dashboard";

const DashboardPage = () => {
  return <Dashboard />;
};

export default DashboardPage;
